import Index from '../../pages/snail/beer/index'

const base = 'beer'

const routes = [
    {
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/router/snail/beer.js